import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { URLS } from '../config/urls';
import { WorkflowState } from '../state/state.state';
import { AlertService } from 'projects/shared-new/src/lib/services-new/alert.service';
import { FileStatus } from '../types/types';
import { StateService } from '../state.service';

@Injectable({
  providedIn: 'root',
})
export class ProcessService {
  constructor(private store: Store<{ workflow: WorkflowState }>) {}

  private httpClient = inject(HttpClient);
  private alertService = inject(AlertService);
  private stateService = inject(StateService);

  getProcess(processId: string): void {
    this.httpClient.get<FileStatus>(`${URLS.PROCESS}/${processId}`).subscribe({
      next: (process) => {
        delete process.name;
        this.stateService.setFileStatus(process);
        if (['queued', 'running'].includes(process.status)) {
          setTimeout(() => {
            this.stateService.getProcessStatus(process.uid);
          }, 5000);
        } else if (['completed'].includes(process.status)) {
          this.stateService.summarizeFile();
        } else if (['failed', 'cancelled'].includes(process.status)) {
          this.alertService.error(
            'Oops! It seems like there was an issue loading your process. Please try again.',
          );
        }
      },
      error: (error) => {
        this.alertService.error(
          'Oops! It seems like there was an issue loading your process. Please try again.',
        );
      },
    });
  }
}
